module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1019-342535e2a6cfa1b0ced820d597eba1e1.png";